import { render, staticRenderFns } from "./JoinUsBody.vue?vue&type=template&id=61ce7d52&"
import script from "./JoinUsBody.vue?vue&type=script&lang=js&"
export * from "./JoinUsBody.vue?vue&type=script&lang=js&"
import style0 from "./JoinUsBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61ce7d52')) {
      api.createRecord('61ce7d52', component.options)
    } else {
      api.reload('61ce7d52', component.options)
    }
    module.hot.accept("./JoinUsBody.vue?vue&type=template&id=61ce7d52&", function () {
      api.rerender('61ce7d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/AboutUs/JoinUs/JoinUsBody.vue"
export default component.exports